import { alpha, styled } from '@mui/material/styles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: alpha(theme.palette.grey[500], 0.05),
  padding: theme.spacing(0.5),
  overflowX: 'auto',

  '& .MuiToggleButtonGroup-groupedSizeSmall': {
    height: 30,
  },

  '@media print': {
    display: 'none',
  },
}));

export const BtnGroup = styled(ToggleButtonGroup)({
  marginLeft: 8,
});

export const Title = styled('div')(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.text.primary,
  marginRight: 10,
}));

export const RowItem = styled('div')(({ theme }) => ({
  margin: `0 ${theme.spacing(2)}`,
}));
